var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceShapeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3328 7.66667C8.17357 7.66667 9.6658 6.17428 9.6658 4.33333C9.6658 2.49238 8.17357 1 6.3328 1C4.49203 1 2.9998 2.49238 2.9998 4.33333C2.9998 6.17428 4.49203 7.66667 6.3328 7.66667ZM6.3328 7.66667C7.74715 7.66667 9.10357 8.22857 10.1037 9.22876C11.1038 10.229 11.6656 11.5855 11.6656 13M6.3328 7.66667C4.91845 7.66667 3.56203 8.22857 2.56194 9.22876C1.56185 10.229 1 11.5855 1 13",
    stroke: "#8F333B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceShapeIcon);
export default __webpack_public_path__ + "static/media/face-shape-icon.fb954fa41850dfede6da37ec9fe16bb6.svg";
export { ForwardRef as ReactComponent };